let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5EQhG"), load("6wr18"), load("ffEVr"), load("kjZZD"), load("a0oMZ")]).then(() => parcelRequire('BkPha'));